import { render, staticRenderFns } from "./CardWidget.vue?vue&type=template&id=4f864933"
import script from "./CardWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CardWidget.vue?vue&type=style&index=0&id=4f864933&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports